import script from "./IntroItem.vue?vue&type=script&setup=true&lang=js"
export * from "./IntroItem.vue?vue&type=script&setup=true&lang=js"

import "./IntroItem.vue?vue&type=style&index=0&id=38943787&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38943787"]])

export default __exports__